export const gambio = {
  passwordLabel: "Passwort",
  urlHelp:
    "Basis-URL des Shops ohne API-Pfad, z. B. https://shop.example.com. Der API-Pfad wird automatisch angehängt.",
  usernameHelp:
    "E-Mail-Adresse eines Gambio-Admin-Kontos, das die API nutzen darf.",
  passwordHelp: "Passwort dieses Gambio-Admin-Kontos."
};
